import { Component, Input, OnInit } from '@angular/core'
import { IKetshopwebFrontendService } from '@cms/services/ketshopweb-frontend.service'
import {
  GetMenuSetting,
  MenuListStore,
  MenuSettingSelectorLevel3Colum1,
  MenuSettingStore,
  MenuSettingSelectorLevel3Colum2,
  SubMenuColumnBanner,
} from '@cms/store/MenuSetting'

@Component({
  selector: 'ket-add-menu-page',
  templateUrl: './add-menu-page.component.html',
  styleUrls: ['./add-menu-page.component.scss'],
})
export class KetAddMenuPageComponent implements OnInit {
  // Input
  @Input() add_type: 'main' | 'sub' = 'main'
  @Input() sub_id?: number
  @Input() column?: number

  // state
  MenuListStore = MenuListStore
  selected = null
  // listMenu = [] as ReturnType<typeof MenuListStore.get>

  readonly menuType = IKetshopwebFrontendService.MenuType

  ngOnInit(): void {
    // this.initListMenu()
  }

  // initListMenu() {
  //   const state = MenuSettingStore.get()
  //   console.log(state)
  //   for (const lsitem of MenuListStore.get()) {
  //     let check = state.changing.menu.find((x) => x.page_id === lsitem.page_id)
  //     for (const item of state.changing.menu) {
  //       if (item.childrens && item.childrens.length > 0) {
  //         check = item.childrens.find((x) => x.page_id === lsitem.page_id)
  //         if (check) {
  //           break
  //         }
  //         let is_break = false
  //         for (const subitem of item.childrens) {
  //           if (subitem.childrens && subitem.childrens.length > 0) {
  //             check = subitem.childrens.find((x) => x.page_id === lsitem.page_id)
  //             if (check) {
  //               is_break = true
  //               break
  //             }
  //           }
  //         }
  //         if (is_break) {
  //           break
  //         }
  //       }
  //     }

  //     if (!check) {
  //       this.listMenu.push(cloneDeep(lsitem))
  //     }
  //   }
  //   console.log(this.listMenu)
  // }

  selectPage(page_id: number) {
    this.selected = page_id
  }

  async ok() {
    if (!this.selected) {
      return
    }
    if (this.add_type === 'main') {
      const state = MenuSettingStore.get()
      const new_item = MenuListStore.get().find((item) => item.page_id === this.selected)
      state.changing.menu.push(new_item)
    } else if (this.add_type === 'sub' && this.sub_id) {
      const state = MenuSettingStore.get()
      for (const item of state.changing.menu) {
        if (item.page_id === this.sub_id) {
          const new_item = MenuListStore.get().find((item) => item.page_id === this.selected)
          GetMenuSetting('sub', new_item.page_id)
          item.childrens.push(new_item)
          console.log('state.changing.setting[this.sub_id].type', state.changing.setting[this.sub_id].type)
          if (state.changing.setting[this.sub_id].type == 'column_banner') {
            MenuSettingStore.get().changing.sub_menu[new_item.page_id].column = this.column || 1
            SubMenuColumnBanner.set({
              ...SubMenuColumnBanner.get(),
              [this.column || 1]: [...(SubMenuColumnBanner.get()[this.column || 1] || []), new_item],
            })
          }
          break
        }
        if (item.childrens && item.childrens.length > 0) {
          const check = item.childrens.find((x) => x.page_id === this.sub_id)
          if (check) {
            const new_item = MenuListStore.get().find((item) => item.page_id === this.selected)
            check.childrens.push(new_item)
            GetMenuSetting('sub', new_item.page_id)

            MenuSettingStore.get().changing.sub_menu[new_item.page_id].column = this.column || 1
            const column = MenuSettingStore.get().changing.sub_menu[new_item.page_id].column
            if (column == 1) {
              MenuSettingSelectorLevel3Colum1.set([
                ...(MenuSettingSelectorLevel3Colum1.get() || []),
                check.childrens[check.childrens.length - 1],
              ])
            } else if (column == 2) {
              MenuSettingSelectorLevel3Colum2.set([
                ...(MenuSettingSelectorLevel3Colum2.get() || []),
                check.childrens[check.childrens.length - 1],
              ])
            }
            break
          }
        }
      }
    }

    let list_state = MenuListStore.get()
    list_state = list_state.filter((x) => x.page_id !== this.selected)
    MenuListStore.set(list_state)

    return true
  }
}
